export default {"src":"/_next/static/media/txtevm.09ecbb42.svg","height":33,"width":101,"blurWidth":0,"blurHeight":0};